import React from "react";
import PropTypes from "prop-types";
import { Popup, Icon } from "semantic-ui-react";

const NotaCell = ({ nota }) => {
	if (!nota || nota.length <= 25) {
		return React.createElement("span", null, nota);
	}

	return React.createElement(Popup, {
		trigger: React.createElement(
			"span",
			null,
			nota.substring(0, 25),
			"...",
			React.createElement(Icon, {
				name: "comment alternate outline",
				size: "small",
				style: { marginLeft: 4, cursor: "pointer", color: "#286b92" },
			})
		),
		content: nota,
		position: "top center",
		size: "small",
		inverted: true,
	});
};

NotaCell.propTypes = {
	nota: PropTypes.string,
};

NotaCell.defaultProps = {
	nota: "",
};

export const chatTagsColumns = [
	{ label: "Plataforma", key: "chat.channel.platform.name", format: "string", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Cuenta", key: "chat.channel.label", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Grupos", key: "chat.group.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Usuario", key: "chat.user.fullName", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Contacto", key: "chat.contact.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{ label: "Teléfono", key: "chat.contact.phone", format: "phone", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Etiqueta", key: "tag.name", format: "string", headerPosition: "center", dataPosition: "left", width: 1 },
	{
		label: "Nota",
		key: "nota",
		format: "string",
		headerPosition: "center",
		dataPosition: "left",
		width: 1,
		canSort: false,
		render: ({ nota }) => {
			return React.createElement(NotaCell, { nota });
		},
	},
	{ label: "Fecha Entrada", key: "chat.createdDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
	{ label: "Fecha Cierre", key: "chat.closeDate", format: "dateTime", headerPosition: "center", dataPosition: "center", width: 1 },
];

export default chatTagsColumns;
